import $ from "jquery";
import _ from "lodash";
import { EventEmitter } from "../events/eventEmitter";
export const modalContentSelector = "[data-modal-content]";
class Modal extends EventEmitter {
    constructor() {
        super();
        $(document).on("click", (e) => {
            const lastModal = $("[data-modal-target]").children(".modal-visible").last();
            if (this.clickIsInsideCloseButton(e) ||
                (!this.clickIsInsideContent(e) &&
                    _.some(lastModal.find("[data-modal-allow-click-off]")))) {
                this.hide(lastModal);
            }
        });
    }
    show(modal) {
        const modalTarget = $("[data-modal-target]");
        const visibleModals = modalTarget.children(".modal-visible, .modal-showing");
        if (!_.some(visibleModals))
            modalTarget.empty();
        $("body").addClass("noscroll");
        modalTarget.append(modal);
        const newModal = modalTarget.children().last().addClass("modal-showing");
        this.emit("show", newModal[0]);
        setTimeout(() => {
            newModal.addClass("modal-visible").removeClass("modal-showing");
        });
        setTimeout(() => {
            // newModal.addClass("modal-visible").removeClass("modal-showing");
            const header = newModal
                .find("h2")
                .prop("tabIndex", "0")
                .on("keydown", (e) => handleFocus(e, "down"));
            setTimeout(() => header.trigger("focus"), 300);
            const lastFocusableElement = $(this.findLastFocusableElement(newModal) || $());
            lastFocusableElement.on("keydown", (e) => handleFocus(e, "up"));
            const handleFocus = (e, allowedDirection) => {
                if (e.key !== "Tab")
                    return;
                if (e.shiftKey && allowedDirection === "down") {
                    e.preventDefault();
                    lastFocusableElement.trigger("focus");
                }
                if (!e.shiftKey && allowedDirection === "up") {
                    e.preventDefault();
                    header.trigger("focus");
                }
            };
        });
        return newModal;
    }
    hide(selectorOrModal) {
        setTimeout(() => {
            const modalTarget = $("[data-modal-target]");
            const hidden = selectorOrModal
                ? typeof selectorOrModal === "string"
                    ? $(selectorOrModal)
                    : selectorOrModal
                : modalTarget.children(".modal-visible").last();
            const prevented = [];
            hidden.toArray().forEach((h) => this.emit("willHide", {
                modal: h,
                preventHide: () => prevented.push(h),
            }));
            hidden
                .toArray()
                .filter((h) => !_.some(prevented, (p) => p === h))
                .forEach((h) => {
                $(h).removeClass("modal-visible").find("iframe").remove();
                this.emit("hide", h);
            });
            const visibleModals = modalTarget.children(".modal-visible");
            _.some(visibleModals)
                ? visibleModals.last().find("h2").trigger("focus")
                : $("body").removeClass("noscroll");
        });
    }
    clickIsInsideCloseButton(e) {
        return _.some($(e.target).closest("[data-modal-close]"));
    }
    findLastFocusableElement(container) {
        var _a;
        return Array.from((_a = container[0]) === null || _a === void 0 ? void 0 : _a.getElementsByTagName("*"))
            .reverse()
            .find((e) => this.isFocusable(e));
    }
    isFocusable(element) {
        const input = element;
        if (element.tabIndex < 0 || $(element).is(":hidden")) {
            return false;
        }
        switch (element.tagName) {
            case "A":
                return !!element.href;
            case "INPUT":
                return input.type !== "hidden" && !input.disabled && !input.readOnly;
            case "SELECT":
            case "TEXTAREA":
            case "BUTTON":
                return !input.disabled;
            case "LABEL":
                return true;
            default:
                return false;
        }
    }
    clickIsInsideContent(e) {
        return _.some($(e.target).closest("[data-modal-content]"));
    }
}
export const modal = new Modal();
